import React, {
  useRef,
  useEffect,
  useContext,
  Fragment,
  useCallback,
  useState,
} from "react";
import { useLocation, useHistory } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Typography,
  Fab,
  // CircularProgress,
  // Table,
  // TableBody,
  // TableRow,
  // TableCell,
} from "@material-ui/core";
import MapboxGl from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import {
  CircleMode,
  DragCircleMode,
  DirectMode,
  SimpleSelectMode,
} from "mapbox-gl-draw-circle";
import DrawRectangle from "mapbox-gl-draw-rectangle-mode";
import { Feature } from "geojson";
import { default as areaTurf } from "@turf/area";
import { default as lengthTurf } from "@turf/length";
import { useSnackbar } from "notistack";
import clsx from "clsx";
import ReactResizeDetector from "react-resize-detector";
import { DesignContext } from "../context/design";
import { PoleSizeList } from "../constant/equip-options";
import { getMapserviceStyles } from "../apis/mapservice";
import { MainContext } from "../context/main";
import {
  mapserviceList,
  categoryLayers,
  administLayers,
} from "../constant/roles";
import { getProjectById } from "../apis/project";
import EquipGenSymbol from "./equip-design/equip-gen-symbol";
import {
  scaleTextToZoomLevel,
  zoomLevelToScaleText,
} from "../constant/commons";
import {
  LocationSearching,
  LocationDisabled,
  Home,
  Info,
} from "@material-ui/icons";
import { LangContext } from "../context/lang";
// import Jerdja from "../material/images/jerdja.png";
// import Markermms from "../material/images/marker-mms.png";
import SearchLocation from "./search-location";
import "mapbox-gl/dist/mapbox-gl.css";
// import { orbitgt } from "../util/orbitSdk";

interface IMapDesign {
  mapsize: { w: number; h: number };
}

const useStyle = makeStyles((theme: Theme) => ({
  container: {
    height: "100%",
    width: "100%",
    borderRadius: theme.spacing(0.5),
  },
  mapHalf: {
    height: "100%",
    width: "50%",
    borderRadius: `${theme.spacing(0.5)}px 0px 0px ${theme.spacing(0.5)}px`,
  },
  mms: {
    height: "100%",
    width: "50%",
    borderRadius: `0px ${theme.spacing(0.5)}px ${theme.spacing(0.5)}px 0px`,
    "& #responsive-wrapper": {
      borderRadius: `0px ${theme.spacing(0.5)}px ${theme.spacing(
        0.5
      )}px 0px !important`,
    },
  },
  hide: { display: "none" },
  measure: {
    position: "absolute",
    zIndex: 11,
    bottom: theme.spacing(0.5),
    left: theme.spacing(0.5),
    padding: theme.spacing(1),
  },
  divScaleText: {
    position: "absolute",
    bottom: theme.spacing(0.5),
    left: theme.spacing(0.5),
    zIndex: 10,
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    background: `#ffffffa3`,
    borderRadius: theme.spacing(1.5),
  },
  divMyLocation: {
    position: "absolute",
    bottom: theme.spacing(6),
    left: theme.spacing(1),
    zIndex: 10,
  },
  projectTitle: {
    position: "absolute",
    zIndex: 1,
    right: 0,
    top: theme.spacing(1),
    background: "#ffffffab",
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    borderRadius: `${theme.spacing(4)}px 0px 0px ${theme.spacing(4)}px`,
    boxShadow: theme.shadows[5],
  },
  homeBbox: {
    position: "absolute",
    zIndex: 1,
    right: theme.spacing(0.5),
    top: theme.spacing(6),
    color: "#595a5a",
  },
  mmsIcon: {
    position: "absolute",
    zIndex: 1,
    right: theme.spacing(1),
    bottom: theme.spacing(3),
  },
  jerdja: {
    height: theme.spacing(4.75),
  },
  divInfo: {
    position: "absolute",
    bottom: theme.spacing(12),
    left: theme.spacing(1),
    zIndex: 10,
  },
}));

const MapDesign = (props: IMapDesign) => {
  const classes = useStyle();
  const mapRef = useRef<HTMLDivElement | any>(null);
  // const orbitRef = useRef<HTMLDivElement | any>(null);
  const { mapsize } = props;
  const history = useHistory();
  const { state } = useLocation();
  const stateParam = JSON.parse(String(state));
  const { enqueueSnackbar } = useSnackbar();
  const { userInfo } = useContext(MainContext);
  const {
    map,
    // orbitgt,
    setmap,
    event,
    setevent,
    setelectrictLayers,
    setadministrativeLayers,
    setbasemap,
    setstylemap,
    setcad,
  } = useContext(DesignContext);
  const { lang } = useContext(LangContext);
  const eventType = event.type;
  const eventFeature = event.feature;
  const [zoomLevel, setzoomLevel] = useState(0);
  const [locate, setlocate] = useState<Boolean>(false);
  // const [jerdja, setjerdja] = useState<Boolean>(false);
  // const [mmsViewer, setmmsViewer] = useState<any>(undefined);

  const renderMeasure = (et: string, feature: Feature) => {
    if (et === "measure-area") {
      const areaValue: number = areaTurf({
        type: "FeatureCollection",
        features: [feature],
      });
      if (areaValue > 1000000) {
        return `พื้นที่ : ${Number(
          (areaValue / 1000000).toFixed(3)
        ).toLocaleString()} ตารางกิโลเมตร`;
      } else {
        return `พื้นที่ : ${Number(
          areaValue.toFixed(3)
        ).toLocaleString()} ตารางเมตร`;
      }
    } else {
      const lengthValue: number = lengthTurf({
        type: "FeatureCollection",
        features: [feature],
      });
      if (lengthValue < 1) {
        return `ความยาว : ${Number(
          (lengthValue * 1000).toFixed(3)
        ).toLocaleString()} เมตร`;
      } else {
        return `ความยาว : ${Number(
          lengthValue.toFixed(3)
        ).toLocaleString()} กิโลเมตร`;
      }
    }
  };

  const toggleLocation = () => {
    const mapContext: MapboxGl.Map | any = map;
    const geolocation: MapboxGl.GeolocateControl = mapContext._controls.find(
      (control: any) => control._geolocateButton
    );
    geolocation.trigger();
    setlocate(!locate);
  };

  const toggleInfo = () => {
    if (event.type === "info") {
      setevent({ ...event, type: undefined });
    } else {
      setevent({ ...event, type: "info" });
    }
  };

  const initMap = useCallback(async () => {
    const meaTiles = await fetch(`${process.env.REACT_APP_MEA_TILE}`)
      .then((rs) => rs.json())
      .then((rs) => rs);
    const apiKeyOrtho = await fetch(`${process.env.REACT_APP_MAPSTD}`)
      .then((rs) => rs.text())
      .then((rs) => rs);
    const mapserviceRole = mapserviceList.find(
      (ml) => ml.roles.findIndex((mr) => mr === userInfo?.role) >= 0
    )?.layerId;
    const promiseMapservice: any = mapserviceRole?.map((layerId: string) =>
      getMapserviceStyles(layerId)
    );

    const rsMapserviceStyles = await Promise.all(promiseMapservice);
    let combindLayers: any = meaTiles;
    const allEquipment = [
      ...categoryLayers.overhead.groupX,
      ...categoryLayers.overhead.groupZ,
      ...categoryLayers.overhead.groupA,
      ...categoryLayers.underground.groupY,
      ...administLayers,
    ];
    combindLayers.layers.map((layer: any, index: number) => {
      if (
        layer.layout &&
        layer.layout.visibility &&
        layer.layout.visibility === "none"
      ) {
        delete combindLayers.layers[index];
      }
      return null;
    });
    combindLayers.sources = {
      ...meaTiles.sources,
      nostra: {
        type: "raster",
        tiles: [
          `${process.env.REACT_APP_NOSTRA_TILE}/tile/{z}/{y}/{x}?blankTile=false`,
        ],
        tileSize: 256,
      },
      "mea-ortho": {
        type: "raster",
        tiles: [
          `${process.env.REACT_APP_MEAORTHO}/tile/{z}/{y}/{x}?token=${apiKeyOrtho}&blankTile=false`,
        ],
        tileSize: 256,
      },
    };
    combindLayers.layers = [
      ...meaTiles.layers,
      {
        id: "nostra",
        type: "raster",
        source: "nostra",
        minzoom: 0,
        maxzoom: 22,
        layout: {
          visibility: "none",
        },
      },
      {
        id: "mea-ortho",
        type: "raster",
        source: "mea-ortho",
        minzoom: 0,
        maxzoom: 22,
        layout: {
          visibility: "none",
        },
      },
    ];
    let preStyle = {
      ...combindLayers,
      layers: combindLayers.layers.filter((layer: string) => layer),
    };
    await rsMapserviceStyles.map((rs: any, index: number) => {
      const mapserviceStyle = rs.data[0];

      preStyle.sprite = mapserviceStyle.sprite;
      preStyle.glyphs = mapserviceStyle.glyphs;
      const hideLayers = mapserviceStyle.layers.map((l: any) => ({
        ...l,
        layout: { ...l.layout, visibility: index === 0 ? "visible" : "none" },
      }));
      preStyle.sources = {
        ...preStyle.sources,
        ...mapserviceStyle.sources,
      };
      preStyle.layers = [...preStyle.layers, ...hideLayers];
      return null;
    });
    const initialMapStyle = {
      ...preStyle,
      layers: preStyle.layers.map((layer: any) => {
        const hasSourceLayer = allEquipment.find(
          (sl) => sl.key === layer["source-layer"]
        );
        if (layer["source-layer"] && hasSourceLayer) {
          return {
            ...layer,
            layout: {
              ...layer.layout,
              visibility: hasSourceLayer.check ? "visible" : "none",
            },
          };
        } else {
          return layer;
        }
      }),
    };

    setadministrativeLayers(administLayers);
    setelectrictLayers(categoryLayers);

    const mapRender = new MapboxGl.Map({
      container: mapRef ? mapRef.current : "",
      style: initialMapStyle,
      bounds: [100.315185, 13.478294, 100.94301, 13.974256],
      maxBounds: [97.3, 5.59, 105.660416, 20.503936],
      preserveDrawingBuffer: true,
    });

    // const loadJerdJa = new Promise((resolve, reject) => {
    //   mapRender.loadImage(Jerdja, function (error: any, res: any) {
    //     mapRender.addImage("jerdja-icon", res);

    //     resolve(true);
    //   });
    // });
    // const loadMarker = new Promise((resolve, reject) => {
    //   mapRender.loadImage(Markermms, function (error: any, res: any) {
    //     mapRender.addImage("marker-icon", res);

    //     resolve(true);
    //   });
    // });
    // await Promise.all([loadJerdJa, loadMarker]);

    const draw = new MapboxDraw({
      displayControlsDefault: false,
      userProperties: true,
      modes: {
        ...MapboxDraw.modes,
        draw_circle: CircleMode,
        drag_circle: DragCircleMode,
        draw_rectangle: DrawRectangle,
        direct_select: DirectMode,
        simple_select: SimpleSelectMode,
      },
    });

    const geolocate = new MapboxGl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
      },
      trackUserLocation: true,
      showAccuracyCircle: false,
    });

    mapRender.addControl(draw);
    mapRender.addControl(geolocate);

    const stateJson = state && typeof state === "string" && JSON.parse(state);
    const projectId = stateJson?._id;
    const rsProject = await getProjectById(projectId);

    if (rsProject?.data && rsProject.data.length === 1) {
      if (rsProject.data[0].designs) {
        const equips = rsProject.data[0].designs.filter((ds: any) =>
          String(ds.id).includes("equip")
        );
        const annos = rsProject.data[0].designs.filter((ds: any) =>
          String(ds.id).includes("anno")
        );
        await equips.map(async (eq: any) => {
          const equipSources = eq.source.data;
          let img = new Image();

          img.width = 100;
          img.height =
            equipSources.properties.equip_type === "equip-cable" &&
            equipSources.properties.cableType !== "aerial"
              ? 20
              : equipSources.properties.equip_type === "equip-riser-transformer"
              ? 60
              : 100;
          img.src = `data:image/svg+xml,${encodeURIComponent(
            ReactDOMServer.renderToString(
              <EquipGenSymbol property={equipSources.properties} />
            )
          )}`;
          img.onload = (event: any) => {
            mapRender.addImage(
              eq.type === "line"
                ? eq.paint["line-pattern"]
                : eq.layout["icon-image"],
              img
            );
          };
          img.onerror = (error: any) => {
            console.log(error);
          };
        });
        setevent({ ...event, designEquips: equips, anno: annos });
      }

      mapRender.on("zoom", (e: MapboxGl.MapEventType["zoom"]) => {
        setzoomLevel(e.target.getZoom());
      });

      mapRender.on("load", (e: MapboxGl.MapEventType["load"]) => {
        if (rsProject.data[0].imports) {
          const cads = rsProject.data[0].imports.filter(
            (cad: any) => cad.img_url
          );
          cads.map((cad: any) =>
            mapRender?.addLayer({
              id: `${cad.url}`,
              source: {
                type: "image",
                url: cad.img_url,
                coordinates: cad.bbox,
              },
              type: "raster",
              paint: { "raster-opacity": 1 },
            })
          );
          setcad(cads);
        }
        setmap(e.target);
        setstylemap(e.target.getStyle());
        rsProject.data[0].bbox && mapRender.fitBounds(rsProject.data[0].bbox);
      });

      mapRender.once("idle", (e: { type: "idle"; target: MapboxGl.Map }) => {
        const equips = rsProject.data[0].designs
          ? rsProject.data[0].designs.filter((ds: any) =>
              String(ds.id).includes("equip")
            )
          : [];
        const annos = rsProject.data[0].designs
          ? rsProject.data[0].designs.filter((ds: any) =>
              String(ds.id).includes("anno")
            )
          : [];
        equips.map(async (eq: any) => {
          e.target.addLayer(
            eq.type === "line"
              ? {
                  ...eq,
                  paint: {
                    ...eq.paint,
                    "line-width":
                      eq.source.data.properties.cableType === "aerial" ? 10 : 3,
                  },
                }
              : {
                  ...eq,
                  layout: {
                    ...eq.layout,
                    "icon-size": [
                      "interpolate",
                      ["exponential", 2],
                      ["zoom"],
                      10,
                      0.01,
                      18.384615384615,
                      0.35,
                    ],
                  },
                },
            `gl-draw-polygon-fill-inactive.cold`
          );

          return null;
        });

        if (annos.length > 0) {
          annos.map((anNo: any) => {
            if (anNo.source.data) {
              const configAnNo =
                typeof anNo.layout["text-size"] === "number"
                  ? {
                      ...anNo,
                      layout: {
                        ...anNo.layout,
                        "text-max-width": 100,
                        "text-allow-overlap": true,
                        "text-size": [
                          "interpolate",
                          ["exponential", 2],
                          ["zoom"],
                          0,
                          0,
                          scaleTextToZoomLevel(500),
                          anNo.layout["text-size"],
                        ],
                      },
                    }
                  : {
                      ...anNo,
                      layout: {
                        ...anNo.layout,
                        "text-max-width": 100,
                        "text-allow-overlap": true,
                      },
                    };
              e.target.addLayer(
                configAnNo,
                `gl-draw-polygon-fill-inactive.cold`
              );
            }
            return null;
          });
        }
      });
    } else {
      enqueueSnackbar("Opp!! Something wrong.", {
        variant: "error",
      });
      history.replace("/app/design/projects");
    }
  }, [
    userInfo,
    setelectrictLayers,
    enqueueSnackbar,
    history,
    setevent,
    setmap,
    setstylemap,
    state,
  ]);

  useEffect(() => {
    // const script = document.createElement("script");
    if (!map) {
      initMap();
    }
    return () => {
      if (map) {
        setmap(undefined);
        setelectrictLayers(undefined);
        setbasemap("openmaptile");
        map.remove();
        // document.body.removeChild(script);
      }
    };
  }, [map, initMap]);

  useEffect(() => {
    map?.resize();
    return () => {};
  }, [mapsize, map]);

  useEffect(() => {
    const _drawCreated = (e: {
      features: Feature[];
      target: MapboxGl.Map | any;
      type: "draw.create";
    }) => {
      const mapEvent = e.target;
      const drawEvent = mapEvent._controls.find(
        (control: any) => control.modes
      );
      const equiptype: any = eventType;
      if (equiptype.includes("equip")) {
        drawEvent.setFeatureProperty(e.features[0].id, "equip_type", equiptype);
        drawEvent.setFeatureProperty(e.features[0].id, "workFunc", "IN.");
        drawEvent.setFeatureProperty(e.features[0].id, "strokeWidth", 1);
        drawEvent.setFeatureProperty(e.features[0].id, "stroke", "#000000");
        drawEvent.setFeatureProperty(e.features[0].id, "strokeOpacity", 1);
        drawEvent.setFeatureProperty(e.features[0].id, "fill", "#ffffff");
        drawEvent.setFeatureProperty(e.features[0].id, "fillOpacity", 0.01);
        if (equiptype === "equip-pole") {
          drawEvent.setFeatureProperty(
            e.features[0].id,
            "poleSize",
            PoleSizeList[0].value
          );
        } else if (equiptype === "equip-cable") {
          drawEvent.setFeatureProperty(e.features[0].id, "cableType", "onPole");
          drawEvent.setFeatureProperty(e.features[0].id, "strokeWidth", 5);
        } else if (equiptype === "equip-relay") {
          drawEvent.setFeatureProperty(e.features[0].id, "relayType", "RL");
          drawEvent.setFeatureProperty(e.features[0].id, "textFill", "#595A5A");
        } else if (equiptype === "equip-switch") {
          drawEvent.setFeatureProperty(
            e.features[0].id,
            "switchType",
            "disconnecting_normally"
          );
        } else if (equiptype === "equip-meter") {
          drawEvent.setFeatureProperty(
            e.features[0].id,
            "meterType",
            "meter1fase"
          );
        }
        setevent({
          ...event,
          type: equiptype,
          feature: drawEvent.getAll().features[0],
        });
      } else if (equiptype.includes("anno-shape")) {
        drawEvent.setFeatureProperty(e.features[0].id, "equip_type", equiptype);
        drawEvent.setFeatureProperty(e.features[0].id, "id", e.features[0].id);
        drawEvent.setFeatureProperty(
          e.features[0].id,
          "fill-color",
          "rgb(56,56,56)"
        );
        drawEvent.setFeatureProperty(e.features[0].id, "fill-opacity", 0.5);
        drawEvent.setFeatureProperty(
          e.features[0].id,
          "fill-outline-color",
          "rgb(56,56,56)"
        );
        const drawFeature = drawEvent.getAll().features[0];
        if (equiptype === "anno-shape-rectangle") {
          const annoLayers = mapEvent
            .getStyle()
            .layers.filter((layer: any) => String(layer.id).includes("shape"));

          const shapeLayer: MapboxGl.Layer = {
            id: `anno-shape-${drawFeature.id}`,
            type: "fill",
            source: {
              type: "geojson",
              data: drawFeature,
            },
            paint: {
              "fill-color": drawFeature.properties["fill-color"],
              "fill-opacity": drawFeature.properties["fill-opacity"],
              "fill-outline-color":
                drawFeature.properties["fill-outline-color"],
            },
          };
          const hasLabel = annoLayers.find(
            (layer: any) => layer.layout?.visibility === "none"
          );

          if (Boolean(hasLabel)) {
            mapEvent.getSource(hasLabel.id).setData(drawFeature);
            map?.setLayoutProperty(hasLabel.id, "visibility", "visible");
          } else {
            map?.addLayer(shapeLayer);
          }
          setevent({
            ...event,
            type: undefined,
            anno: event.anno ? [...event.anno, shapeLayer] : [shapeLayer],
          });
          drawEvent.deleteAll();
        } else {
          setevent({
            ...event,
            type: equiptype,
            feature: drawFeature,
          });
        }
      } else if (equiptype.includes("anno-label")) {
        drawEvent.setFeatureProperty(
          e.features[0].id,
          "equip_type",
          "anno-label"
        );
        drawEvent.setFeatureProperty(e.features[0].id, "text", "Text label");
        drawEvent.setFeatureProperty(e.features[0].id, "text-font", "Kanit");
        drawEvent.setFeatureProperty(e.features[0].id, "id", e.features[0].id);
        drawEvent.setFeatureProperty(e.features[0].id, "text-size", [
          "interpolate",
          ["exponential", 2],
          ["zoom"],
          0,
          0,
          scaleTextToZoomLevel(500),
          24,
        ]);
        drawEvent.setFeatureProperty(e.features[0].id, "text-rotate", 0);
        drawEvent.setFeatureProperty(e.features[0].id, "text-color", "#000000");

        const drawFeature = drawEvent.getAll().features[0];

        setevent({
          ...event,
          type: "anno-label",
          feature: drawFeature,
        });
      } else if (equiptype.includes("measure")) {
        setevent({
          ...event,
          feature: e.features[0],
          // type: undefined,
        });
      }
    };

    const _drawSelectionChange = (e: {
      features: Feature[];
      points: [];
      target: MapboxGl.Map;
      type: "draw.selectionchange";
    }) => {
      const equiptype: any = eventType;
      const mapEvent: any = e.target;
      const drawEvent = mapEvent._controls.find(
        (control: any) => control.modes
      );
      if (equiptype.includes("equip") && e.features.length === 0) {
        setevent({ ...event, type: undefined });
        drawEvent.deleteAll();
        // mapEvent.off("draw.selectionchange", _drawSelectionChange);
      } else if (equiptype.includes("anno-shape") && e.features.length === 0) {
        const drawHot = mapEvent.getStyle().sources["mapbox-gl-draw-hot"].data
          .features;

        const drawCold = mapEvent.getStyle().sources["mapbox-gl-draw-cold"].data
          .features;

        const activeFeatures = drawHot[0] ? drawHot : drawCold;
        if (activeFeatures.length > 0) {
          const drawFeature = drawEvent.get(activeFeatures[0].properties.id);
          const annoLayers = mapEvent
            .getStyle()
            .layers.filter((layer: any) => String(layer.id).includes("shape"));

          const shapeLayer: MapboxGl.Layer = {
            id: `anno-shape-${drawFeature.id}`,
            type:
              drawFeature.properties.equip_type !== "anno-shape-stroke"
                ? "fill"
                : "line",
            source: {
              type: "geojson",
              data: drawFeature,
            },
            paint:
              drawFeature.properties.equip_type !== "anno-shape-stroke"
                ? {
                    "fill-color": drawFeature.properties["fill-color"],
                    "fill-opacity": drawFeature.properties["fill-opacity"],
                    "fill-outline-color":
                      drawFeature.properties["fill-outline-color"],
                  }
                : {
                    "line-color": drawFeature.properties["fill-outline-color"],
                  },
          };

          const hasLabel = annoLayers.find(
            (layer: any) => layer.layout?.visibility === "none"
          );

          if (Boolean(hasLabel)) {
            mapEvent.getSource(hasLabel.id).setData(drawFeature);
            map?.setLayoutProperty(hasLabel.id, "visibility", "visible");
            setevent({
              ...event,
              type: undefined,
              anno: [...event.anno, shapeLayer],
            });
          } else {
            map?.addLayer(shapeLayer);
            setevent({
              ...event,
              type: undefined,
              anno: event.anno ? [...event.anno, shapeLayer] : [shapeLayer],
            });
          }
          drawEvent.deleteAll();
          mapEvent?.getSource("mapbox-gl-draw-cold").setData({
            type: "FeatureCollection",
            features: [],
          });
          mapEvent?.getSource("mapbox-gl-draw-hot").setData({
            type: "FeatureCollection",
            features: [],
          });
          mapEvent.off("draw.selectionchange", _drawSelectionChange);
        }
      } else if (equiptype.includes("anno-label") && e.features.length === 0) {
        const drawHot = mapEvent.getStyle().sources["mapbox-gl-draw-hot"].data
          .features;

        const drawCold = mapEvent.getStyle().sources["mapbox-gl-draw-cold"].data
          .features;

        const activeFeatures = drawHot[0] ? drawHot : drawCold;

        if (activeFeatures.length > 0) {
          const drawFeature = drawEvent.get(activeFeatures[0].properties.id);
          const annoLayers = mapEvent
            .getStyle()
            .layers.filter((layer: any) =>
              String(layer.id).includes("anno-label")
            );
          const labelLayer: MapboxGl.Layer = {
            id: `anno-label-${drawFeature.id}`,
            type: "symbol",
            source: {
              type: "geojson",
              data: drawFeature,
            },
            layout: {
              "text-field": "{text}",
              "text-pitch-alignment": "auto",
              "text-rotation-alignment": "map",
              "text-font": [drawFeature.properties["text-font"]],
              "text-size": [
                "interpolate",
                ["exponential", 2],
                ["zoom"],
                10,
                0,
                scaleTextToZoomLevel(500),
                Number(drawFeature.properties["text-size"]),
              ],
              "text-rotate": drawFeature.properties["text-rotate"],
            },
            paint: {
              "text-color": drawFeature.properties["text-color"],
            },
          };

          const hasLabel = annoLayers.find(
            (layer: any) => layer.layout?.visibility === "none"
          );
          if (Boolean(hasLabel)) {
            mapEvent.getSource(hasLabel.id).setData(drawFeature);
            map?.setLayoutProperty(hasLabel.id, "visibility", "visible");
          } else {
            map?.addLayer(labelLayer);
          }
          setevent({
            ...event,
            type: undefined,
            anno: event.anno ? [...event.anno, labelLayer] : [labelLayer],
          });
          drawEvent.deleteAll();
          mapEvent?.getSource("mapbox-gl-draw-cold").setData({
            type: "FeatureCollection",
            features: [],
          });
          mapEvent?.getSource("mapbox-gl-draw-hot").setData({
            type: "FeatureCollection",
            features: [],
          });
        }
      } else if (equiptype.includes("measure") && e.features.length === 0) {
        setevent({
          ...event,
          feature: undefined,
          type: undefined,
        });
        drawEvent.deleteAll();
        mapEvent?.getSource("mapbox-gl-draw-cold").setData({
          type: "FeatureCollection",
          features: [],
        });
        mapEvent?.getSource("mapbox-gl-draw-hot").setData({
          type: "FeatureCollection",
          features: [],
        });
        drawEvent.changeMode("simple_select");
      }
    };

    const _drawUpdate = (e: {
      action: "move" | "change_coordinates";
      features: Feature[];
      target: MapboxGl.Map;
      type: "draw.update";
    }) => {
      setevent({
        ...event,
        feature: e.features[0],
      });
    };

    if (map && eventType && eventType !== "info" && !eventFeature) {
      let mapContext: MapboxGl.Map | any = map;
      const draw = mapContext._controls.find((control: any) => control.modes);

      draw.changeMode(
        eventType === "equip-cable" ||
          eventType === "anno-shape-stroke" ||
          eventType === "measure-length"
          ? "draw_line_string"
          : eventType === "anno-shape-rectangle"
          ? "draw_rectangle"
          : eventType === "anno-shape-circle"
          ? "draw_circle"
          : eventType === "measure-area"
          ? "draw_polygon"
          : "draw_point",
        eventType === "anno-shape-circle" ? { initialRadiusInKm: 0.01 } : {}
      );

      map.on("draw.create", _drawCreated);
      map.on("draw.selectionchange", _drawSelectionChange);
      eventType.includes("measure") && map.on("draw.update", _drawUpdate);
    }
    return () => {
      if (map && eventType && eventType !== "info" && !eventFeature) {
        const mapContext: MapboxGl.Map | any = map;

        const draw = mapContext._controls.find((control: any) => control.modes);

        draw.deleteAll();
        draw.changeMode("simple_select");
        map.off("draw.create", _drawCreated);
        map.off("draw.selectionchange", _drawSelectionChange);
        eventType.includes("measure") && map.off("draw.update", _drawUpdate);
      }
    };
  }, [map, eventType]);

  useEffect(() => {
    const mouseEnterLayer = (e: MapboxGl.MapMouseEvent) => {
      e.target.getCanvas().style.cursor = "pointer";
    };

    const mouseLeaveLayer = (e: MapboxGl.MapMouseEvent) => {
      e.target.getCanvas().style.cursor = "";
    };

    const getLayerInfo = (e: MapboxGl.MapMouseEvent) => {
      const features = e.target.queryRenderedFeatures(e.point);
      const feature: any = features[0];
      const keys = Object.keys(feature.properties);
      let tableRowString = "";
      keys.map(
        (k: string) =>
          (tableRowString = `${tableRowString}
        <tr>
          <td>${k}</td>
          <td>${feature.properties[k]}</td>
        </tr>`)
      );
      const popup = new MapboxGl.Popup({ closeOnClick: true })
        .setLngLat(e.lngLat)
        .setMaxWidth("350px")
        .setHTML(
          `<div style='width:100%'>
            <div>
              <p style="font-family: 'Montserrat-Medium','Kanit-Medium';font-size:16px">${feature.sourceLayer}</p>
            </div>
            <div style="max-height:200px;overflow-y:auto;font-family: 'Montserrat-Medium','Kanit-Medium';">
              <table >
                ${tableRowString}
              </table>
            </div>
          </div>`
        );
      popup.addTo(e.target);
    };

    const msLayers = map
      ?.getStyle()
      .layers?.filter(
        (l: any) =>
          mapserviceList[1].layerId
            .filter((msl: any, i: number) => i > 1)
            .findIndex((li: any) => l.source === li) >= 0
      );
    if (eventType === "info" && map) {
      msLayers?.map((l: any) => map.on("mouseenter", l.id, mouseEnterLayer));
      msLayers?.map((l: any) => map.on("mouseleave", l.id, mouseLeaveLayer));
      msLayers?.map((l: any) => map.on("click", l.id, getLayerInfo));
    }
    return () => {
      if (eventType === "info" && map) {
        msLayers?.map((l: any) => map.off("mouseenter", l.id, mouseEnterLayer));
        msLayers?.map((l: any) => map.off("mouseleave", l.id, mouseLeaveLayer));
        msLayers?.map((l: any) => map.off("click", l.id, getLayerInfo));
      }
    };
  }, [map, eventType]);

  // useEffect(() => {
  //   if (orbitgt && map && userInfo?.role !== "customer") {
  //     const AMap = orbitgt.mapping3d.sdk.viewer.AMap;
  //     const Constants = orbitgt.mapping3d.sdk.viewer.Constants;
  //     const Bounds = orbitgt.mapping3d.sdk.viewer.Bounds;

  //     const applicationName = "MEA MMS 2020";
  //     const loginOptions = new AMap();
  //     loginOptions.set(
  //       Constants.LOGIN_MODE,
  //       Constants.LOGINMODE_GUEST_PUBLISHER
  //     );

  //     loginOptions.set(Constants.LOGIN_HOST, "https://gismms.mea.or.th");
  //     loginOptions.set(Constants.LOGIN_PUBLICATION_NAME, "mms2020");

  //     const options = new AMap();
  //     options.set(Constants.STARTUP_AUTO_LOGIN, loginOptions);
  //     const viewer = new orbitgt.mapping3d.sdk.viewer.SDKViewer(
  //       applicationName,
  //       orbitRef.current,
  //       options
  //     );
  //     const handleWorkspaceOpened = async () => {
  //       viewer.onFieldOfViewsChanged.add((e: any) => {
  //         const fieldOfView = viewer.getFieldOfViews2D();
  //         const mapObj = fieldOfView.elements.elements[0];
  //         const hasLayer = map.getLayer("marker-jerdja");
  //         if (hasLayer) {
  //           const mmsSource: any = map.getSource("mms-marker");
  //           mmsSource.setData({
  //             type: "Feature",
  //             properties: {},
  //             geometry: {
  //               type: "Point",
  //               coordinates: [mapObj.spatialPoint.x, mapObj.spatialPoint.y],
  //             },
  //           });
  //           // map.set;
  //           map.setLayoutProperty(
  //             "direction-jerdja",
  //             "icon-rotate",
  //             Number(mapObj.properties.elements.elements[1].v) + 180
  //           );
  //         } else {
  //           map.addSource("mms-marker", {
  //             type: "geojson",
  //             data: {
  //               type: "Feature",
  //               properties: {},
  //               geometry: {
  //                 type: "Point",
  //                 coordinates: [mapObj.spatialPoint.x, mapObj.spatialPoint.y],
  //               },
  //             },
  //           });
  //           map.addLayer({
  //             id: "direction-jerdja",
  //             type: "symbol",
  //             source: "mms-marker",
  //             layout: {
  //               "icon-image": "marker-icon",
  //               "icon-size": 0.1,
  //               "icon-ignore-placement": true,
  //               "icon-offset": [0, 75],
  //               "icon-rotate":
  //                 Number(mapObj.properties.elements.elements[1].v) + 180,
  //               visibility: "visible",
  //             },
  //           });
  //           map.addLayer({
  //             id: "marker-jerdja",
  //             type: "symbol",
  //             source: "mms-marker",
  //             layout: {
  //               "icon-image": "jerdja-icon",
  //               "icon-size": 0.02,
  //               "icon-ignore-placement": true,
  //               visibility: "visible",
  //             },
  //           });
  //         }
  //       });
  //       viewer.doAction("setSetting:sidebarLeftVisible:false");
  //       let bounds = new Bounds("4326");
  //       bounds.is3D = true;
  //       bounds.minZ = -100;
  //       bounds.maxZ = 100;
  //       bounds.minX = 100.297885;
  //       bounds.minY = 13.483957;
  //       bounds.maxX = 100.937391;
  //       bounds.maxY = 14.167834;
  //       const promiseFootprint2d = await viewer.getFootprints2D(bounds, 4000);
  //       const footPrints2dGeojson: any = {
  //         type: "FeatureCollection",
  //         features: promiseFootprint2d.elements.elements.map((elm: any) => ({
  //           type: "Feature",
  //           properties: { objectId: elm.objectId, z: elm.spatialPoint.z },
  //           geometry: {
  //             type: "Point",
  //             coordinates: [
  //               Number(elm.spatialPoint.x),
  //               Number(elm.spatialPoint.y),
  //             ],
  //           },
  //         })),
  //       };
  //       map.addSource("mms-footprints", {
  //         type: "geojson",
  //         generateId: true,
  //         data: footPrints2dGeojson,
  //         maxzoom: 21,
  //       });

  //       setmmsViewer(viewer);
  //       // viewer.doAction("setSetting:sidebarRightVisible:false");
  //     };

  //     const handleReady = () => {
  //       viewer.setSize(
  //         orbitRef.current.offsetWidth,
  //         orbitRef.current.offsetHeight
  //       );
  //       viewer.onWorkspaceOpened.add(handleWorkspaceOpened);
  //     };

  //     viewer.isReady.then(handleReady);
  //   }
  //   return () => {};
  // }, [orbitgt, map, userInfo]);

  // useEffect(() => {
  //   const onClickMmsFootprint = (e: any) => {
  //     const features = e.target.queryRenderedFeatures(e.point, {
  //       layers: ["mms-footprints"],
  //     });
  //     const fieldofViews2D = mmsViewer.getFieldOfViews2D();
  //     const Coordinate = orbitgt.mapping3d.sdk.viewer.Coordinate;
  //     const Constants = orbitgt.mapping3d.sdk.viewer.Constants;
  //     let options = new orbitgt.mapping3d.sdk.viewer.AMap();
  //     options.set(
  //       Constants.STARTUP_PAN,
  //       fieldofViews2D.elements.elements[0].properties.elements.elements[1].v
  //     );
  //     options.set(
  //       Constants.STARTUP_TILT,
  //       fieldofViews2D.elements.elements[0].properties.elements.elements[4].v
  //     );
  //     let focus = Coordinate.fromXYZ(
  //       "4326",
  //       features[0].geometry.coordinates[0],
  //       features[0].geometry.coordinates[1],
  //       features[0].properties.z
  //     );
  //     mmsViewer.setFocusPositionWithOptions(focus, options);
  //   };
  //   const onMouseEnter = (e: any) => {
  //     e.target.getCanvas().style.cursor = "pointer";
  //   };
  //   const onMouseLeave = (e: any) => {
  //     e.target.getCanvas().style.cursor = "";
  //   };
  //   if (map && mmsViewer && jerdja) {
  //     if (!Boolean(map.getLayer("mms-footprints"))) {
  //       map.addLayer({
  //         id: "mms-footprints",
  //         type: "circle",
  //         source: "mms-footprints",
  //         paint: {
  //           "circle-color": "rgba(38, 71, 145, 0.9)",
  //           "circle-radius": [
  //             "interpolate",
  //             ["exponential", 1],
  //             ["zoom"],
  //             17,
  //             4,
  //             21,
  //             10,
  //           ],
  //         },
  //         layout: {
  //           visibility: "visible",
  //         },
  //         minzoom: 17,
  //       });
  //     } else {
  //       map.setLayoutProperty("mms-footprints", "visibility", "visible");
  //     }
  //     map.on("mouseenter", "mms-footprints", onMouseEnter);
  //     map.on("mouseleave", "mms-footprints", onMouseLeave);
  //     map.on("click", "mms-footprints", onClickMmsFootprint);
  //   } else if (map && mmsViewer && !jerdja) {
  //     Boolean(map.getLayer("mms-footprints")) &&
  //       map.setLayoutProperty("mms-footprints", "visibility", "none");
  //   }
  //   return () => {
  //     if (map && mmsViewer && jerdja) {
  //       map.off("mouseenter", "mms-footprints", onMouseEnter);
  //       map.off("mouseleave", "mms-footprints", onMouseLeave);
  //       map.off("click", "mms-footprints", onClickMmsFootprint);
  //     }
  //   };
  // }, [jerdja, map, mmsViewer, orbitgt]);

  return (
    <Fragment>
      <div
        ref={mapRef}
        className={clsx(
          classes.container,
          // jerdja ? classes.mapHalf : classes.container,
          "mapboxgl-map mode-simple_select mouse-none"
        )}
      >
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={(w: number, h: number) => {
            map?.resize();
          }}
        />
        {event.type?.includes("measure") && event.feature && (
          <Paper className={classes.measure}>
            <Typography variant="subtitle2">
              {renderMeasure(event.type, event.feature)}
            </Typography>
          </Paper>
        )}
        {map && (
          <Fragment>
            <SearchLocation />
            {userInfo?.role !== "customer" && (
              <Fragment>
                {/* <Fab
                  variant="round"
                  className={classes.mmsIcon}
                  color={jerdja ? "primary" : "default"}
                  disabled={!Boolean(mmsViewer)}
                  onClick={() => {
                    if (jerdja) {
                      map?.setLayoutProperty(
                        "direction-jerdja",
                        "visibility",
                        "none"
                      );
                      map?.setLayoutProperty(
                        "marker-jerdja",
                        "visibility",
                        "none"
                      );
                    }
                    if (!jerdja && map?.getLayer("marker-jerdja")) {
                      map?.setLayoutProperty(
                        "direction-jerdja",
                        "visibility",
                        "visible"
                      );
                      map?.setLayoutProperty(
                        "marker-jerdja",
                        "visibility",
                        "visible"
                      );
                    }

                    setjerdja(!jerdja);
                  }}
                >
                  {mmsViewer ? (
                    <img src={Jerdja} className={classes.jerdja} />
                  ) : (
                    <CircularProgress color="primary" />
                  )}
                </Fab> */}
                <div className={classes.divInfo}>
                  <Fab
                    variant="round"
                    size="small"
                    color={event.type === "info" ? "primary" : "secondary"}
                    onClick={toggleInfo}
                  >
                    <Info />
                  </Fab>
                </div>
              </Fragment>
            )}

            <div className={classes.projectTitle}>
              <Typography variant="body1">{`${lang.data.workOrderNo} ${stateParam.work_order_no}`}</Typography>
            </div>
            {stateParam && stateParam.bbox && (
              <Fab
                variant="round"
                size="small"
                className={classes.homeBbox}
                onClick={() => {
                  map.fitBounds(stateParam.bbox);
                }}
              >
                <Home />
              </Fab>
            )}

            <div className={classes.divMyLocation}>
              <Fab
                variant="round"
                size="small"
                color={locate ? "primary" : "secondary"}
                onClick={toggleLocation}
              >
                {locate ? <LocationDisabled /> : <LocationSearching />}
              </Fab>
            </div>
            <div className={classes.divScaleText}>
              <Typography variant="body2">{`1:${Number(
                zoomLevelToScaleText(zoomLevel).toFixed(0)
              ).toLocaleString()}`}</Typography>
            </div>
          </Fragment>
        )}
      </div>
      {/* <div ref={orbitRef} className={clsx(jerdja ? classes.mms : classes.hide)}>
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={(w: number, h: number) => {
            mmsViewer?.setSize(w, h);
          }}
        />
      </div> */}
    </Fragment>
  );
};

export default MapDesign;
